/**
 * Portal Manta · getQtdObra
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';

function getQtdObra(codigo, od){
  const map = {
    '1.2.1':  {cats:['duplicacoes','contornos'], field:'km', und:'km'},
    '1.2.2':  {cats:['marginais'],               field:'km', und:'km'},
    '1.2.3':  {cats:['diamantes','trombetas','parclos','rotatorias'], field:'n', und:'un'},
    '1.2.5':  {cats:['faixas'],                  field:'km', und:'km'},
    '1.2.7':  {cats:['ciclovias'],               field:'km', und:'km'},
    '1.2.9':  {cats:['oaes'],                    field:'n',  und:'un'},
    '1.2.10': {cats:['passarelas'],              field:'n',  und:'un'},
  };
  const m = map[codigo];
  if (!m || !od) return {qtd:null, und:'—'};
  const qtd = m.cats.reduce((s,cat)=> s + (od[cat]||[]).reduce((ss,it)=> ss+(it[m.field]||0), 0), 0);
  return {qtd: qtd || null, und: m.und};
}

export { getQtdObra };
export default getQtdObra;
